<template>
  <!-- 督办小组 -->
  <div class="edu_pages">
    <div class="edu_pages_content_box">
      <div class="edu_page_title_box">
        <div class="title_box">
          <div class="color_lump_box"></div>
          <span>督办小组管理</span>
        </div>
        <div class="edu_operation_box">
          <el-select
            style="width:200px"
            v-model="listRequestData.streetOfficesId"
            clearable
            size="mini"
            placeholder="请选择所属街道"
          >
            <el-option
              v-for="item in streetList"
              :key="item.id"
              :label="item.regionName"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <div class="search_icon_box button-box" @click="getDataList()">
            <div></div>
            <span>搜索</span>
          </div>
          <div class="add_icon_box button-box" @click="openAddBox(1)">
            <div></div>
            <span>新增</span>
          </div>
        </div>
      </div>
      <div class="edu_pages_content_body_box">
        <div class="edu_table_box">
          <el-table
            :data="dataList.list"
            height="100%"
            :header-cell-style="{ background: '#DDE4FF', color: '#474859' }"
            class="table_box"
          >
            <el-table-column label="序号" width="70" align="center">
              <template slot-scope="scope">
                {{
                  listRequestData.pageSize * (listRequestData.pageNum - 1) +
                    scope.$index +
                    1
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="teamName"
              label="小组名称"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="teamLeaderName"
              label="组长名称"
              width="200"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="teamMemberName"
              label="成员名称"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="leaderPhone"
              label="联系方式"
              width="200"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="streetOfficesName"
              label="所属街道"
              width="200"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column label="操作" width="180" align="center">
              <template slot-scope="rowData">
                <el-link
                  type="primary"
                  @click="editClick(rowData.row)"
                  :underline="false"
                  >编辑</el-link
                >
                <el-divider direction="vertical"></el-divider>
                <el-link
                  type="danger"
                  @click="delData(rowData.row.supTeamId)"
                  :underline="false"
                  >删除</el-link
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="edu_pagination_box">
          <el-pagination
            @current-change="handleCurrentChange"
            background
            :current-page="dataList.pageNum"
            :page-size="listRequestData.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="dataList.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog
      :title="actionCate == 1 ? '新增督办小组' : '修改督办小组'"
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
      :visible.sync="actionDataBox"
      size="40%"
    >
      <div class="dialog_box">
        <el-form
          ref="ruleForm"
          :rules="rules"
          :model="actionDataInfo"
          label-width="0px"
        >
          <div class="form-row-item-box">
            <div class="form-item-box">
              <span>小组名称:</span>
              <el-form-item prop="teamName">
                <el-input
                  size="small"
                  clearable
                  style="width:100%"
                  v-model.trim="actionDataInfo.teamName"
                  placeholder="请输入小组名称"
                ></el-input>
              </el-form-item>
            </div>
            <div class="form-item-box">
              <span>所属街道:</span>
              <el-form-item prop="streetOfficesId">
                <el-select
                  style="width:100%"
                  v-model="actionDataInfo.streetOfficesId"
                  clearable
                  size="small"
                  placeholder="请选择所属街道"
                  @change="streetOfficesChange"
                >
                  <el-option
                    v-show="streetList.length == 0"
                    label="暂无所属街道"
                    value="暂无所属街道"
                    :disabled="true"
                  >
                  </el-option>
                  <el-option
                    v-show="streetList.length != 0"
                    v-for="item in streetList"
                    :key="item.id"
                    :label="item.regionName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="form-row-item-box">
            <div class="form-item-box">
              <span>小组组长:</span>
              <el-form-item prop="tempLeader">
                <el-cascader
                  placeholder="请选择小组组长"
                  style="width:100%"
                  size="small"
                  v-model="actionDataInfo.tempLeader"
                  :options="supervisionLeaderSelectData"
                  :props="{ expandTrigger: 'hover' }"
                  @change="leaderchange"
                  ref="tempLeaderRef"
                  clearable
                >
                  <template slot-scope="{ node, data }">
                    <span>{{ data.label }}</span>
                    <span v-if="!node.isLeaf">
                      ({{ data.children.length }})
                    </span>
                  </template>
                </el-cascader>
              </el-form-item>
            </div>
            <div class="form-item-box">
              <span>联系方式:</span>
              <el-form-item prop="leaderPhone">
                <el-input
                  size="small"
                  clearable
                  style="width:100%"
                  v-model.trim="actionDataInfo.leaderPhone"
                  placeholder="请输入联系方式"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-row-item-box">
            <div class="form-item-box" style="width:100%">
              <span>小组成员:</span>
              <el-form-item prop="teamMember">
                <el-select
                  @change="memberchange"
                  style="width:100%"
                  v-model="actionDataInfo.teamMember"
                  multiple
                  filterable
                  allow-create
                  default-first-option
                  size="small"
                  placeholder="请选择小组成员"
                >
                  <el-option
                    v-show="supervisionMember.length == 0"
                    label="暂无小组成员"
                    value="暂无小组成员"
                    :disabled="true"
                  >
                  </el-option>
                  <el-option
                    v-show="supervisionMember.length != 0"
                    v-for="item in supervisionMember"
                    :key="item.schoolId"
                    :label="item.schoolName"
                    :value="item.schoolId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <div class="dialog_save_cancel_box">
          <div class="cancel_item_box" @click="handleClose">取消</div>
          <div
            class="save_item_box"
            @click="saveClick('ruleForm')"
          >
            确定
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    var reg = /^1[3456789]\d{9}$/;
    var checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!reg.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    return {
      actionDataBox: false,
      listRequestData: {
        eduId: this.$store.getters.getEduData.eduId,
        pageNum: 1,
        pageSize: 20,
        streetOfficesId: ""
      },
      dataList: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: []
      },

      actionDataInfo: {
        eduId: this.$store.getters.getEduData.eduId,
        supTeamId: 0,
        teamName: "",
        tempLeader: "",
        leaderPhone: "",
        teamMember: "",
        streetOfficesId: ""
      },
      supervisionMember: [],

      supervisionLeaderSelectData: [],
      actionCate: 1,
      streetList: [], //街道列表
      rules: {
        teamName: [{ required: true, message: " ", trigger: "blur" }],
        streetOfficesId: [{ required: true, message: " ", trigger: "change" }],
        tempLeader: [{ required: true, message: " ", trigger: "change" }],
        leaderPhone: [
          { required: true, validator: checkPhone, trigger: "change" }
        ],
        teamMember: [{ type: 'array', required: true, message: " ", trigger: "change" }]
      }
    };
  },
  watch: {},
  computed: {},
  methods: {
    openAddBox(cate) {
      this.actionCate = cate;
      this.actionDataBox = true;
      // if (cate == 1) {
        this.clearData();
        this.actionDataInfo.supTeamId = "";
      // }
      // setTimeout(() => {
      //   this.$refs.ruleForm.resetFields();
      // }, 100);
    },

    handleClose() {
      this.clearData();
      this.actionDataBox = false;
      this.$refs.ruleForm.resetFields();
    },
    clearData() {
     this.actionDataInfo.teamMember = "";
      this.actionDataInfo.tempLeader = "";
      this.actionDataInfo.teamName = "";
      this.actionDataInfo.leaderPhone = "";
      this.actionDataInfo.streetOfficesId = "";
      this.actionDataInfo.supTeamId = 0; 
      // this.$refs.ruleForm.resetFields();
    },
    handleCurrentChange(val) {
      this.listRequestData.pageNum = val;
      console.log(`当前页: ${val}`);
      this.getDataList();
    },
    editClick(dataInfo) {
      this.actionDataInfo.streetOfficesId =
        dataInfo.streetOfficesId == 0 ? "" : dataInfo.streetOfficesId;
      this.actionDataInfo.tempLeader = ["oneListId", dataInfo.tempLeader];
      this.supervisionLeaderSelectData = [];
      this.actionDataInfo.supTeamId = dataInfo.supTeamId;
      this.getSupervisionLeader();
      this.getSupervisionMember();
      this.actionDataInfo.teamName = dataInfo.teamName;
      this.actionDataInfo.leaderPhone = dataInfo.leaderPhone;
      this.actionDataInfo.eduId = dataInfo.eduId;
      var dataList = dataInfo.teamMember.split(",");
      var teamMember = [];
      dataList.forEach((item) => {
        teamMember.push(parseInt(item));
      });
      this.actionDataInfo.teamMember = teamMember;
      // this.openAddBox(2);
      this.actionCate = 2;
      this.actionDataBox = true;
    },
    leaderchange(val) {
      this.supervisionMember = [];
      this.actionDataInfo.leaderPhone = "";
      this.actionDataInfo.teamMember = [];
      if (val.length > 0) {
        this.supervisionLeaderSelectData.forEach((item) => {
          if (item.children.length > 0) {
            item.children.forEach((iitem) => {
              if (val[1] == iitem.value) {
                this.actionDataInfo.leaderPhone = iitem.userPhone || "";
              }
            });
          }
        });
        this.getSupervisionMember();
      } else {
        this.supervisionMember = [];
      }
    },
    memberchange(val) {
      // console.log(this.actionDataInfo.teamMember);
      // console.log(val);
    },
    // 所属街道改变时
    streetOfficesChange(val) {
      this.supervisionLeaderSelectData = [];
      this.actionDataInfo.tempLeader = [];
      this.actionDataInfo.leaderPhone = "";
      this.actionDataInfo.teamMember = [];
      this.supervisionMember = [];
      if (val) {
        this.getSupervisionLeader();
      }
    },
    // 获取小组组长
    async getSupervisionLeader() {
      let res = await this.$Http.getSupervisionLeader({
        eduId: parseInt(this.$store.getters.getEduData.eduId),
        streetOfficesId: this.actionDataInfo.streetOfficesId,
        teamId: this.actionDataInfo.supTeamId
      });
      if (res.code == 200) {
        res.data.forEach((element) => {
          var dataInfo = {
            value: "oneListId",
            label: element.name,
            children: [],
            disabled: false
          };
          element.users.forEach((userList) => {
            dataInfo.children.push({
              value: userList.userId,
              label: userList.userName,
              userPhone: userList.userPhone
            });
          });
          dataInfo.disabled = dataInfo.children.length >= 1 ? false : true;
          this.supervisionLeaderSelectData.push(dataInfo);
        });
        // console.log(this.supervisionLeader)
      } else if (res.code == 101) {
        this.supervisionLeaderSelectData = [];
      } else {
        this.supervisionLeaderSelectData = [];
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },

    // 获取小组成员
    async getSupervisionMember() {
      let res = await this.$Http.getSupervisionMember({
        userId: this.actionDataInfo.tempLeader[1],
        streetOfficesId: this.actionDataInfo.streetOfficesId,
        teamId: this.actionDataInfo.supTeamId
      });
      if (res.code == 200) {
        this.supervisionMember = res.data || [];
        // console.log(this.supervisionMember)
      } else if (res.code == 101) {
        this.supervisionMember = [];
      } else {
        this.supervisionMember = [];
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },

    async getDataList() {
      let req = Object.assign({}, this.listRequestData);
      let res = await this.$Http.getEduSupervisionGroup(req);
      if (res.code == 200) {
        this.dataList.pageSize = res.data.pageSize;
        this.dataList.pageNum = res.data.pageNum;
        this.dataList.total = res.data.total;
        this.dataList.pages = res.data.pages;
        this.dataList.list = res.data.list;
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    saveClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.actionData();
        } else {
          return false;
        }
      });
    },
    async actionData() {
      var sendData = JSON.parse(JSON.stringify(this.actionDataInfo));
      if (this.actionCate == 1) {
        delete sendData.supTeamId;
      }
      sendData.teamMember = sendData.teamMember.join(",");
      sendData.tempLeader = sendData.tempLeader[1]
        ? sendData.tempLeader[1]
        : "";
      let verifyList = [
        "teamName",
        "tempLeader",
        "leaderPhone",
        "teamMember",
        "streetOfficesId"
      ];
      for (let index = 0; index < verifyList.length; index++) {
        const element = verifyList[index];
        if (sendData[element] == "") {
          this.$message({
            message: "请填写完整信息后再进行提交",
            type: "warning"
          });
          return;
        }
      }
      let res = await this.$Http.actionEduSupervisionGroup(sendData, true);
      if (res.code == 200) {
        this.$message({
          message: res.messsage,
          type: "success"
        });
        this.getDataList();
        this.handleClose();
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },

    // 删除数据
    delData(dataId) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var requestData = {
            supTeamId: dataId
          };
          let res = await this.$Http.delEduSupervisionGroup(requestData);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getDataList();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    },
    async getBureauStreetList() {
      let res = await this.$Http.getBureauStreetList({
        parCode: this.$store.getters.getEduData.regionCode
      });
      if (res.code == 200) {
        this.streetList = res.data || [];
      } else if (res.code == 101) {
        this.streetList = [];
      } else {
        this.streetList = [];
      }
    }
  },
  created() {
    this.getDataList();
    this.getBureauStreetList();
  },
  mounted() {}
};
</script>
<style scoped lang="scss">
@import "../../../../public/css/edu_pages.scss";
</style>
